import { render, staticRenderFns } from "./AlbumDetails.vue?vue&type=template&id=59537022&scoped=true"
import script from "./AlbumDetails.vue?vue&type=script&lang=js"
export * from "./AlbumDetails.vue?vue&type=script&lang=js"
import style0 from "./AlbumDetails.vue?vue&type=style&index=0&id=59537022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59537022",
  null
  
)

export default component.exports